import { render, staticRenderFns } from "./widget-app.vue?vue&type=template&id=a3be71fa&"
import script from "./widget-app.vue?vue&type=script&lang=js&"
export * from "./widget-app.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports